import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d5cf184"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gridEncontrar" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Filtrar por Estatus", -1))
const _hoisted_3 = { class: "gridposts" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
          return (_openBlock(), _createElementBlock("p", {
            class: _normalizeClass([_ctx.toColor(filter), "post"]),
            style: {"cursor":"pointer"},
            key: filter,
            onClick: () => $props.filterEmpleadors(filter)
          }, _toDisplayString(filter), 11, _hoisted_4))
        }), 128))
      ])
    ])
  ], 64))
}